import type { OktaAuth } from '@okta/okta-auth-js';
import type { OktaUser } from '@sportybot-web/auth/context';
import type { SportySDK } from '@sportybot-web/services/sporty-gateway/client';
import type { QueryClient } from '@tanstack/react-query';

import { AppShell } from '@sportybot-web/components/app-shell/app-shell';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

export interface RootRouteContext {
  authClient: OktaAuth;
  queryClient: QueryClient;
  sportySdk: SportySDK;
  user: OktaUser;
}

export const Route = createRootRouteWithContext<RootRouteContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>

      <TanStackDevtools
        config={{ position: 'bottom-right' }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          {
            name: 'Tanstack Query',
            render: <ReactQueryDevtoolsPanel />,
          },
        ]}
      />
    </>
  );
}
